import imagePlaceholder from '../assets/image-placeholder.svg';
import config from '../config';


// Get the information text for the courses in general
export const getCoursesInfo = () => async (dispatch) => {
  const res = await fetch(`${config.fetchURL}/pages?slug=kurzusok`);
  const data = await res.json();

  const info = {
    text: data[0].acf.leiras,
    link: data[0].acf.kerdoiv_link
  };

  dispatch({
    type: 'GET_COURSES_INFO',
    payload: info
  });
};


// Get each courses
export const getCourses = () => async (dispatch) => {
  const res = await fetch(`${config.fetchURL}/courses?_embed`);
  const data = await res.json();

  const courses = data.map(item => {
    const image = {};
    if (item._embedded['wp:featuredmedia']) {
      const sizes = item._embedded['wp:featuredmedia'][0].media_details.sizes;
      image.full = sizes.full.source_url;
      image.large = sizes.large ? sizes.large.source_url : null;
      image.medium_large = sizes.medium_large ? sizes.medium_large.source_url : null;
      image.medium = sizes.medium ? sizes.medium.source_url : null;
      image.thumbnail = sizes.thumbnail ? sizes.thumbnail.source_url : null;
    } else {
      image.full = imagePlaceholder;
    }

    return {
      title: item.title.rendered,
      slug: item.slug,
      description: {
        short: item.acf.rovid_leiras,
        long: item.acf.bovebb_leiras
      },
      image
    };
  });

  dispatch({
    type: 'GET_COURSES',
    payload: courses
  });
};



// WEBPACK FOOTER //
// ./src/actions/courseActions.js